/// 3 Kas: panoya kopyalama. navigator.clipboard bazi durumlarda (menu kapanirken, odak yokken,
/// eski tarayici) sessizce reddediyordu ama "Kopyalandi" yaziyorduk. Once eski yol (execCommand,
/// tiklama aninda senkron calisir), olmazsa clipboard API. Gercek sonucu doner.
export default async function kopyala(text) {
  const s = String(text ?? "");
  try {
    const t = document.createElement("textarea");
    t.value = s;
    t.setAttribute("readonly", "");
    t.style.position = "fixed";
    t.style.top = "-1000px";
    t.style.opacity = "0";
    document.body.appendChild(t);
    t.select();
    t.setSelectionRange(0, s.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(t);
    if (ok) return true;
  } catch (_) {}
  try {
    await navigator.clipboard.writeText(s);
    return true;
  } catch (_) {
    return false;
  }
}
